export * from './is-session-active';

export const ONE_MINUTE_IN_MS = 60 * 1000;
export const TEN_SECONDS_IN_MS = ONE_MINUTE_IN_MS / 6;
export const BANK_CUSTOMER_USER_SESSION_LIFETIME_MINUTES = 15;
export const USER_INACTIVITY_COUNTDOWN_LENGTH_SECONDS = 90;
